"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var effector_1 = require("effector");
var QBAdapter_1 = require("../QBAdapter");
exports.default = (function (Chat$) {
    var setSession = effector_1.createEffect().use(QBAdapter_1.setSession);
    Chat$.on(setSession.done, function (state, payload) { return (__assign(__assign({}, state), { session: payload.params })); });
    return setSession;
});
//# sourceMappingURL=setSession.js.map